export default __webpack_public_path__ + "static/media/testimonial_4.573c9710.png";